import { Layer } from '../layer';

// コンバートに失敗したレイヤー
export class ConvertErrorLayer extends Layer
{
    public get layerType() : string { return "convertError"; }

    // Label9 でのコンポーネント名
    private _componentName : string = "";
    public get componentName() { return this._componentName; }
    public set componentName(componentName) { this._componentName = componentName; }

    // 追加説明
    private _description : string = "";
    public get description() { return this._description; }
    public set description(description) { this._description = description; }

    public clone()
    {
        var cloned = new ConvertErrorLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : ConvertErrorLayer)
    {
        layer.componentName = this._componentName;
        layer.description = this._description;

        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.componentName = this._componentName;
        jsonObject.description = this._description;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : Layer
    {
        var layer = new ConvertErrorLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.componentName != null) { this._componentName = jsonData.componentName; }
        if(jsonData.description != null) { this._description = jsonData.description; }

        super.loadParameterFromJson(jsonData);
    }
}